import type React from "react";
import {
  FluentProvider,
  createLightTheme,
  createDarkTheme,
  type BrandVariants,
} from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { darkModeAtom, isRTLAtom } from "../store";

const brandTheme: BrandVariants = {
  10: "#01090A",
  20: "#021F21",
  30: "#043639",
  40: "#064C51",
  50: "#076269",
  60: "#097981",
  70: "#0B8F99",
  80: "#0CA7B3",
  90: "#1DBDC9",
  100: "#3FC5CF",
  110: "#66C5CC",
  120: "#89CDD2",
  130: "#A9D7DA",
  140: "#C3E2E4",
  150: "#D9EBED",
  160: "#EEF6F7",
};

const lightTheme = createLightTheme(brandTheme);
const darkTheme = createDarkTheme(brandTheme);

export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const darkMode = useAtomValue(darkModeAtom);
  const isRTL = useAtomValue(isRTLAtom);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <FluentProvider theme={theme} dir={isRTL ? "rtl" : "ltr"}>
      {children}
    </FluentProvider>
  );
};
